import { useRef, useState } from "react";

import useChatApi from "./chatbot.service";
import useDragEvent from "./useDragEvent";

const SIZE_STORE = "chatbot-size";
const POSITION_STORE = "chatbot-modal-position";

function getSizeFromStore() {
  const size = localStorage.getItem(SIZE_STORE);
  if (size) return JSON.parse(size);
}

function setSizeToStore(size) {
  localStorage.setItem(SIZE_STORE, JSON.stringify(size));
}

export default function useChatbot(props) {
  const [{ isLoading }, sendPrompt] = useChatApi({ planId: props.planId, onSuccess, onError });
  const [isShown, setIsShown] = useState(false);
  const [modalSize, setModalSize] = useState(getSizeFromStore);
  const dragEvent = useDragEvent(POSITION_STORE);
  const [conversations, setConversations] = useState([]);
  const chatInputRef = useRef(null);

  function onSuccess(response) {
    const content = response["ai_response"];
    setConversations((data) => [...data, { role: "ai", content }]);
  }

  function onError(error) {
    const errorMessage = error.data.errors;
    setConversations((data) => [...data, { role: "ai", content: errorMessage, isError: true }]);
  }

  function onToggle() {
    setIsShown((show) => !show);
  }

  function onClose() {
    setIsShown(false);
  }

  function onSend() {
    if (isLoading || !chatInputRef.current || !chatInputRef.current.value.trim()) return;

    const content = chatInputRef.current.value;
    setConversations((data) => [...data, { role: "user", content }]);
    chatInputRef.current.value = "";
    chatInputRef.current.style.height = "";

    sendPrompt(content);
  }

  function onResizeStop(event, direction, element, delta) {
    const currentRect = element.getBoundingClientRect();
    const newSize = {
      width: currentRect.width,
      height: currentRect.height,
    };

    setSizeToStore(newSize);
    setModalSize(newSize);
  }

  return { isShown, isLoading, modalSize, conversations, chatInputRef, onToggle, onClose, onSend, onResizeStop, dragEvent };
}



// WEBPACK FOOTER //
// ./src/components/chatbot/chatbot.controller.js